import React from 'react';
import { string, func } from 'prop-types';
import Icon from 'components/icon';

export default function ErrorMessage({ errorMessage, closeModal }) {
    return (
        <div className="error-message">
            <div className="btn-wrapper">
                <button onClick={() => closeModal(false)} className="close-btn modal-closer">
                    <Icon glyph="cross" />
                </button>
            </div>
            <div className="title">
                Error
            </div>
            <div className="message">
                {errorMessage}
            </div>
        </div>
    );
}

ErrorMessage.propTypes = {
    errorMessage: string.isRequired,
    closeModal: func.isRequired
};
